// store/iframeLogsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IframeLog {
  type: "iframe-console" | "iframe-error";
  level?: "log" | "warn" | "error" | "info" | "debug";
  args?: string[];
  message?: string;
  stack?: string;
  source?: string;
  lineno?: number;
  colno?: number;
  path?: string;
}

interface IframeLogsState {
  logs: IframeLog[];
}

const initialState: IframeLogsState = {
  logs: [],
};

export const iframeLogsSlice = createSlice({
  name: "iframeLogs",
  initialState,
  reducers: {
    addLog: (state, action: PayloadAction<IframeLog>) => {
      state.logs.push(action.payload);
    },
    clearLogs: (state) => {
      state.logs = [];
    },
  },
});

export const { addLog, clearLogs } = iframeLogsSlice.actions;
export default iframeLogsSlice.reducer;
